import { faCommentDots, faPlus, faShoppingCart, faThLarge, faThList, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AdminContext, UserContext } from '../../../App';

const OrderHeader = () => {
    const [isAdmin, setIsAdmin] = useContext(AdminContext)
    const [loggedInUser, setLoggedInUser] = useContext(UserContext)
    useEffect(() => {
      fetch('https://assignment-11-samiun.herokuapp.com/isAdmin?email=' + loggedInUser.email)
      .then(res => res.json())
      .then(data => (data.length > 0) && setIsAdmin(true))
    }, [loggedInUser.email]) 
    return (
        <div>
            <div className="d-flex justify-content-between">
            <div className="ms-5">
                <img src={require('../../../images/logo.png').default} className="mt-3 mb-5" alt=""/>
                <div>
                    <Link to="/order" style={{textDecoration: 'none'}}><div className="d-flex text-color" style={{cursor: 'pointer'}}>
                        <FontAwesomeIcon icon={faShoppingCart} />
                        <p className="ms-2">Order</p>
                    </div></Link>
                    <Link to="/orderlist" style={{textDecoration: 'none'}}><div className="d-flex text-color" style={{cursor: 'pointer'}}>
                        <FontAwesomeIcon icon={faThList} />
                        <p className="ms-2">Order List</p>
                    </div></Link>
                    <Link to="/review" style={{textDecoration: 'none'}}><div className="d-flex text-color" style={{cursor: 'pointer'}}>
                        <FontAwesomeIcon icon={faCommentDots} />
                        <p className="ms-2">Review</p>
                    </div></Link>
                </div>
                {isAdmin && <div>
                    <Link to="/orderlistadmin" style={{textDecoration: 'none'}}><div className="d-flex text-color" style={{cursor: 'pointer'}}>
                        <FontAwesomeIcon icon={faThList} />
                        <p className="ms-2">Order List</p>
                    </div></Link>
                    <Link to="/addservice" style={{textDecoration: 'none'}}><div className="d-flex text-color" style={{cursor: 'pointer'}}>
                        <FontAwesomeIcon icon={faPlus} />
                        <p className="ms-2">Add Service</p>
                    </div></Link>
                    <Link to="/addadmin" style={{textDecoration: 'none'}}><div className="d-flex text-color" style={{cursor: 'pointer'}}>
                        <FontAwesomeIcon icon={faUserPlus} />
                        <p className="ms-2">Make Admin</p>
                    </div></Link>
                    <Link to="/manageservices" style={{textDecoration: 'none'}}><div className="d-flex text-color" style={{cursor: 'pointer'}}>
                        <FontAwesomeIcon icon={faThLarge} />
                        <p className="ms-2">Manage Services</p>
                    </div></Link>
                </div>}
            </div>
        </div>
        </div>
    );
};

export default OrderHeader;